var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFavouriteWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFavouriteWhite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.6108835,4.2268673 C11.6490069,4.34453253 11.6649025,4.58154949 11.3435025,4.84697735 L8.69980418,7.03150311 C8.69282566,7.03967611 8.68339172,7.06873566 8.68481327,7.0822276 L9.54381816,10.4068218 C9.62303736,10.7135038 9.55273517,10.8909747 9.47971911,10.9858074 C9.39998298,11.0892023 9.28005572,11.1461538 9.14203598,11.1461538 C9.01513018,11.1461538 8.87543043,11.098024 8.72681366,11.002802 L5.84041766,9.15362868 C5.84041766,9.15388814 5.84041766,9.15388814 5.84041766,9.15388814 C5.83834995,9.15388814 5.7920849,9.15310976 5.78769102,9.15518545 L2.90387965,11.002802 C2.59333523,11.2016783 2.30398486,11.1841648 2.15097421,10.9858074 C2.07782891,10.8909747 2.00752672,10.7135038 2.08674592,10.4068218 L2.94639697,7.07950327 C2.94730159,7.06886539 2.93786766,7.03941665 2.92895066,7.02981662 L0.287061535,4.84710708 C-0.0340799051,4.58167922 -0.0181843731,4.34466226 0.0198098255,4.22699703 C0.057933256,4.10946153 0.183805193,3.90812035 0.599156738,3.88295271 L4.01695459,3.67564395 C4.02729315,3.67330881 4.05223492,3.65501686 4.05882575,3.64334115 L5.31030813,0.446790589 C5.46254339,0.0579893709 5.69205936,0 5.81534666,0 C5.93863396,0 6.16814993,0.0579893709 6.32051442,0.446790589 L7.57290142,3.64580602 C7.5784584,3.65488713 7.60327093,3.67330881 7.61658183,3.67577368 L11.0316658,3.88282298 C11.4470174,3.90799062 11.5727601,4.1093318 11.6108835,4.2268673 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "View-all-friends",
    transform: "translate(-405.000000, -395.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(370.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Friends",
    transform: "translate(0.000000, 101.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "View-friend-User",
    transform: "translate(25.812308, 248.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Pic",
    transform: "translate(4.203077, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey",
    transform: "translate(5.088462, 4.523077)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icFavouriteWhite",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFavouriteWhite);
export default __webpack_public_path__ + "static/media/icFavouriteWhite.954c17d048a5d2d7d90cc5ca5756853d.svg";
export { ForwardRef as ReactComponent };